import actionTypes from '../constants/action-types';

const siteProperties = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_SITE_PROPERTIES:
      return action.payload.properties;
    case actionTypes.SET_SITE_PROPERTY: {
      const { property, value } = action.payload;

      return {
        ...state,
        [property]: value,
      };
    }
    default:
      return state;
  }
};

export default siteProperties;
